import {Component} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {PasswordUtil} from "../../x-components/x-models/password-util";
import {AlertLevel} from "../../../enums/alert-level";
import {AuthenticationService} from "../../../_auth/authentication.service";
import {GlobalAlertService} from "../../../_services/global-alert.service";
import {UserHttpService} from "../../../selfservice/x-http-requests/user-http.service";
import {PasswordEntryComponent} from "../../x-components/password-entry/password-entry.component";
import {EmployeePinSelfComponent} from "./employee-pin-self/employee-pin-self.component";
import {CalendarSubscriptionComponent} from "./calendar-subscription/calendar-subscription.component";

@Component({
  selector: 'app-settings',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    PasswordEntryComponent,
    EmployeePinSelfComponent,
    CalendarSubscriptionComponent
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent {
  passwordUtil: PasswordUtil = new PasswordUtil();

  constructor(private authenticationService: AuthenticationService, private userHttpService: UserHttpService,
              private globalAlertService: GlobalAlertService) {
  }

  changePassword(event: Event) {
    event.preventDefault();
    this.userHttpService.ChangePassword(this.passwordUtil.old, this.passwordUtil.password).subscribe(x => {
      this.globalAlertService.createAlertBannerModel("Erfolg", "Das Passwort wurde erfolgreich geändert. Beim nächsten Login bitte das neue Passwort nutzen.", AlertLevel.success, 5000);
      this.globalAlertService.show();
      this.passwordUtil = new PasswordUtil();
    }, error => {
      this.globalAlertService.createAlertBannerModel("Fehler", "Beim Speichern des Passworts ist ein Fehler aufgetreten.", AlertLevel.error, 3000);
      this.globalAlertService.show()
    })
  }
}
